var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('a',_vm._g(_vm._b({staticClass:"gitlab-link",attrs:{"href":_vm.getLink,"target":"_blank"}},'a',attrs,false),on),[_c('img',{staticClass:"gitlab-link__icon",attrs:{"src":require("@/assets/images/gitlab.svg"),"alt":"Gitlab"}})])]}}])},[_vm._v(_vm._s(_vm.getVersion))])}
var staticRenderFns = []

export { render, staticRenderFns }